const $ = require('jquery');

module.exports = {
  init() {
    // rāda norādīto elementu
    $(document).on('click', '[data-show-sibling]', function (e) {
      e.preventDefault();
      e.stopPropagation();

      const show_target = $(this).data('show-sibling');
      $(this).siblings(show_target).removeClass('hide').removeClass('is-hidden');
    });

    // paslēpj norādīto elementu
    $(document).on('click', '[data-hide]', function (e) {
      e.preventDefault();
      e.stopPropagation();

      const remove_target = $(this).data('hide');
      $(this).closest(remove_target).addClass('hide');
    });

    // nepieciešams, kad nevajag aizvietot saturu
    $(document).on('click', '[data-post]', function (e) {
      e.preventDefault();
      e.stopPropagation();
      if ($(this).hasClass('btn--disabled')) {
        return;
      }
      let href = $(this).attr('href');
      if (typeof href === 'undefined') {
        href = $(this).data('href');
      }

      if ($(this).data('post') == true && (typeof href !== 'undefined')) {
        $.post(href);
        // ::TODO neveiksmīga pieprasījuma gadījumā attēlot notification
      }
    });

    // nospiežot pievieno klasi btn--disabled
    $(document).on('click', '.btn[data-disable-on-click]', function (e) {
      e.preventDefault();
      e.stopPropagation();

      $(this).addClass('btn--disabled');
    });
  },
};
